/**
 * CloseGroupButton
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useCommunities } from 'containers/Api2/index.js';
import { idValues } from 'utils/arrays.js';
import usePersistentState from 'utils/usePersistentState.js';
import { useSearch } from 'utils/urlUtils.js';
import messages from './messages.js';

function CloseGroupButton(props) {
  const { group } = props;
  const [link, setLink] = usePersistentState(sessionStorage, 'groupManageCloseLink');
  const communities = useCommunities();
  const community = idValues(communities).find((comm) => comm.groupId === group.id);
  const { ref } = useSearch();
  useEffect(() => {
    if (ref && ref !== link) {
      setLink(ref);
    }
  }, [ref]);
  useEffect(() => {
    if (!ref && !link && community) {
      setLink(`/communities/${community.id}`);
    }
  }, [community && community.id]);
  return (
    <Button as={Link} variant="light" to={link}>
      <FormattedMessage {...messages.close} />
    </Button>
  );
}

CloseGroupButton.propTypes = {
  group: PropTypes.object,
};

export default CloseGroupButton;
